import { FaqPanel } from "components/faq/FaqPanel";
import styled from "styled-components";

interface IFaqSectionProps {
  onClickSubscriptionText: () => void;
  onOpenCreateScenarioModal: () => void;
}
const FaqSection: React.FC<IFaqSectionProps> = (props) => {
  const { onClickSubscriptionText, onOpenCreateScenarioModal } = props;

  return (
    <FaqPlaceholder>
      <FaqPanel
        onClickSubscriptionText={onClickSubscriptionText}
        onOpenCreateScenarioModal={onOpenCreateScenarioModal}
      />
    </FaqPlaceholder>
  );
};

export default FaqSection;

const FaqPlaceholder = styled.div`
  margin-top: 32px;
`;